function getToken() {
  let str = sessionStorage.getItem("USER_LOGIN");
  if (!str) {
    return null;
  }
  return JSON.parse(str).access;
}

function addDomainToImages(html, domain) {
  if (!html) return html;

  const div = document.createElement("div");
  div.innerHTML = html;

  const images = div.querySelectorAll("img");
  images.forEach((img) => {
    const src = img.getAttribute("src");

    if (src && !src.startsWith("http") && !src.startsWith("data:")) {
      const newSrc = src.startsWith("/")
        ? `${domain}${src}`
        : `${domain}/${src}`;
      img.setAttribute("src", newSrc);
    }
  });

  return div.innerHTML;
}

const map = new Map([["/", ""]]);

export { getToken, map, addDomainToImages };
